import React, { useState, useEffect } from 'react';

const Tip = (props) => {

  // * state 
  const [displayed, setDisplayed] = useState(false);

  // * events 
  const mouseOver = (event) => {
    setDisplayed(true); 
    //console.log('mouseover', displayed);
  }; 
  const mouseOut = (event) => {
    setDisplayed(false); 
  }; 

  // * component mount/update
  useEffect(
    () => {
      setDisplayed(false);
    },
    [props.tipText]
  );

  let out = null;
  let tipClasses = ['tip-hover'];
  if (displayed) {
    tipClasses.push('tip-displayed'); 
  }
  
  if (props.tipText) {
    /*
    out = (<span>&nbsp;&nbsp;<span className='tip-icon' title={props.tipText}>&#128161;</span></span>); 
    out = (<div clasName='tip-block'>
      <span className='tip-icon'>&#128161;</span> <span class='tip-text'>{props.tipText}</span>
    </div>);
    */
    out = (<span onMouseOver={mouseOver} onMouseOut={mouseOut}>&nbsp;&nbsp;<span className='tip-icon'>&#128161;</span>
      <div className={tipClasses.join(' ')}>{props.tipText}</div>
      </span>); 


  }


  return (out);

}; 

export default Tip;